import React, { Component } from 'react';
import { Grid, Row, Col, Panel, ButtonToolbar, Button, Breadcrumb, Input } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';
import axios from 'axios';
import { PAYMENT_METHOD_CHANGE_URL } from '../../actions/url'; 

const paymentMethodList = ['wechatpay', 'alipay', 'creditcard', 'paypal', 'Zelle', 'ApplePay', 'Venmo', 'Cash', 'Other'];

const styles = {
  container: {
    width: '100%',
    margin: '10px auto',
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'center',
    alignItems: 'center',
  },
};

class PaymentMethodModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedPaymentMethod: null,
    }
  }
  componentDidMount() {
    if (this.props.salesOrder && this.props.salesOrder[0]) {
      this.setState({
        selectedPaymentMethod: this.props.salesOrder[0].PaymentType
      })
    }
  }

  handleSaveButtonClick = () => {
    let so_id = null;
    let si_id = null;
    if (this.props.salesOrder[0].SalesOrder_id) {
      so_id = this.props.salesOrder[0].SalesOrder_id;
    }
    if (this.props.salesOrder[0].SalesInvoice_id) {
      si_id = this.props.salesOrder[0].SalesInvoice_id;
    }
    const payment_method = this.state.selectedPaymentMethod;
    axios.post(
      PAYMENT_METHOD_CHANGE_URL,
      {
        so_id,
        si_id,
        payment_method,
      },
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        const returnId = this.props.salesOrder[0].SalesOrder_id ? this.props.salesOrder[0].SalesOrder_id : this.props.salesOrder[0].SalesInvoice_id;
        this.props.successSaved(returnId, payment_method);
      }, (err) => {
        alert(err.data);
        // console.log('err', err);
      });
  }

  renderSaveButton() {
    return (
      <div
        style={{
          width: '100%',
          marginTop: '5px',
          alighItems: 'center',
          textAlign: 'center',
        }}
      >
        <Button
          bsStyle="success"
          // type="reset"
          // disabled={this.shouldQuoteButtonDisable()}
          onClick={this.handleSaveButtonClick}
        >
          <Translate value="save" />
        </Button>
      </div>
    );
  }
  renderEachMethod(method) {
    return (
      <div>
        <label
          style={{
            // width: '200px',
            // display: 'inline-block',
            fontSize: '18px',
          }}
          onClick={() => this.setState({ selectedPaymentMethod: method })}
        >
          {method}
        </label>
        <input
          style={{ marginLeft: '20px' }}
          type="radio"
          name="paymentMethod"
          value={method}
          checked={this.state.selectedPaymentMethod === method}
          onChange={(e) => this.setState({ selectedPaymentMethod: e.currentTarget.value })}
        />
      </div>
    );
  }
  render() {
    return (
      <div style={styles.container}>
        {
          paymentMethodList.map(method => {
            return (
              this.renderEachMethod(method)
            )
          })
        }
        {
          this.renderSaveButton()
        }
      </div>
    );
  }
}

export default PaymentMethodModal;



// WEBPACK FOOTER //
// ./master/jsx/components/Sales/PaymentMethodModal.jsx